import { QC_CONSTANTS } from "./quickCheckConstants";

const nf = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function buildUserReportVM(payload) {
  const { responses, participant, completedAt } = payload;
  
  // 1) Validação dura
  const keys = Array.from({length:20}, (_,i)=>`Q${String(i+1).padStart(2,'0')}`);
  const missing = keys.filter(k => {
    const value = responses?.[k];
    return typeof value !== 'number' || value < 1 || value > 6;
  });
  
  if (missing.length) {
    return {
      status: "incompleto",
      missing,
      version: QC_CONSTANTS.version
    };
  }

  // 2) Partições
  const risco = keys.slice(0,15).map(k => responses[k]);
  const mat   = keys.slice(15).map(k => responses[k]);

  // 3) Positivos (5–6)
  const countPos = arr => arr.filter(v => v >= 5).length;
  const posRisco = countPos(risco);
  const posMat   = countPos(mat);

  // 4) Índices
  const IE = +(((posRisco/15)*6).toFixed(4));
  const IM = +(((posMat  / 5)*6).toFixed(4));
  const IE_termo = +(((IE/6)*5).toFixed(4));

  // 5) Classificações
  const positivesRatio = posRisco / 15;
  const faixa = QC_CONSTANTS.exposureLevels.classifyIE(positivesRatio);
  const nivelIM = QC_CONSTANTS.maturityLevels.classifyIM(IM);

  // 6) Radar 0–6 por eixo
  const radar = mat.map(v => +(((v-1)*(6/5)).toFixed(4)));

  // 7) Textos canônicos
  const interpIE = QC_CONSTANTS.interpretacao_exposicao[faixa];
  const interpIM = QC_CONSTANTS.interpretacao_maturidade[nivelIM];
  const passos   = QC_CONSTANTS.proximos_passos_quadrante[faixa][nivelIM];

  // 8) Eixos
  const eixosKeys = ["governance","data","processes","culture","learning"];
  const eixos = eixosKeys.map((key, i) => {
    const eixo = QC_CONSTANTS.eixos_descricao[key];
    return {
      key,
      rotulo: eixo.rotulo,
      descricao: eixo.descricao,
      respostaLikert: mat[i],                  // 1–6
      notaRadar: radar[i],                     // 0–6
      notaRadarFmt: nf.format(radar[i])        // "x,y"
    };
  });

  // 9) Formatação e cores
  const fmtIE = nf.format(IE);
  const fmtIM = nf.format(IM);
  const fmtTermo = nf.format(IE_termo);
  const colorFaixa = {
    "Vermelho": QC_CONSTANTS.colors.vermelho,
    "Laranja":  QC_CONSTANTS.colors.laranja,
    "Amarelo":  QC_CONSTANTS.colors.amarelo,
    "Verde":    QC_CONSTANTS.colors.verde
  }[faixa];

  // 10) Formatação de data
  let dataConclusao = null;
  if (completedAt) {
    const date = new Date(completedAt);
    dataConclusao = date.toLocaleDateString('pt-BR');
  }

  // 11) Flags sentinela (Q6 e Q15)
  const sentinelFlags = [];
  if (responses.Q06 <= 3) {
    sentinelFlags.push("Canais de denúncia percebidos como inseguros ou ineficientes.");
  }
  if (responses.Q15 <= 3) {
    sentinelFlags.push("Baixa segurança para discordar e levantar riscos sem medo de retaliação.");
  }

  // 12) Eixos fracos (< 3.1)
  const weakAxes = eixos.filter(e => e.notaRadar < 3.1);

  // 13) Hash de auditoria
  let auditHash = '';
  try {
    // Simple hash for browser environment
    const str = JSON.stringify(responses);
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash;
    }
    auditHash = Math.abs(hash).toString(16).padStart(8, '0');
  } catch (e) {
    auditHash = 'n/a';
  }

  return {
    status: "ok",
    version: QC_CONSTANTS.version,
    participante: participant,
    dataConclusao,
    indices: {
      IE, IM, IE_termo,
      IE_fmt: fmtIE, 
      IM_fmt: fmtIM, 
      IE_termo_fmt: fmtTermo,
      faixa, 
      nivelIM, 
      positivesRatio,
      posRisco,
      posMat
    },
    cores: { 
      faixa: colorFaixa, 
      ...QC_CONSTANTS.colors 
    },
    interpretacoes: { 
      exposicao: interpIE, 
      maturidade: interpIM 
    },
    proximosPassos: passos,
    eixos,
    weakAxes,
    sentinelFlags,
    auditHash,
    responses
  };
}